const QUERIES = {
  USERS_LIST: 'users-list',
  Manufactury_list :'manufacury',
  usersList:'Users-List',
  FactorList:'Factor-List',
  DiskList:'Disk-List'
}

export {QUERIES}
